import { BrowserRouter, Routes as AppRoutes, Route, Outlet } from "react-router-dom";
import { IncomingOrdersProvider } from "@/pages/organization-orders/IncomingOrdersProvider";
import ResetPassword from "@/features/admin/reset-password/ResetPassword";
import SignInPage from "@/features/sign-in/SignInPage";
import CreatedAccount from "@/features/admin/sign-up/CreatedAccount";
import SignUpPage from "@/features/admin/sign-up/SignUpPage";
import PrivateRoutes from "@/routes/PrivateRoutes";
import AdminLayout from "@/features/admin-layout/AdminLayout";
import Profile from "@/features/admin/profile/Profile";
import ChangePassword from "@/features/admin/change-password/ChangePassword";
import Organizations from "@/features/organizations/Organizations";
import NewOrganization from "@/features/organizations/new-organization/NewOrganization";
import MenuEditor from "@/features/menu/MenuEditor";
import Settings from "@/features/admin/menus/settings/Settings";
import Templates from "@/pages/templates/Templates";
import NewTemplate from "@/features/newTemplate/NewTemplate";
import TemplateEditor from "@/pages/templates/TemplateEditor";
import TemplateSettings from "@/features/newTemplate/components/Settings";
import { OrganizationLayout, OrganizationTables, OrganizationAvatars } from "@/features/organizations/components";
import OrganizationContent from "@/pages/organization-content/OrganizationContent";
import OrganizationMenus from "@/pages/organization-menus/OrganizationMenus";
import OrganizationSettings from "@/pages/organization-settings/OrganizationSettings";
import AccessManagementPage from "@/pages/access-management/AccessManagementPage";
import Faqs from "@/features/organizations/components/faqs/Faqs";
import UserOrganizationProvider from "@/features/users/UserOrganizationProvider";
import NewMenuWizard from "@/features/new-menu-wizard/NewMenuWizard";
import CreateCatalog from "@/pages/catalog/CreateCatalog";
import CatalogEditor from "@/pages/catalog/CatalogEditor";
import OrganizationDetails from "@/pages/organization-details/OrganizationDetails";
import OrganizationProvider from "@/features/websites/components/OrganizationProvider";
import NewWebsiteWizard from "@/features/organizations/components/websites/newWebsite/NewWebsitesWizard";
import WebsiteEditor from "@/features/website-editor/WebsiteEditor";
import SurveysPage from "@/pages/surveys/SurveysPage";
import SurveyDetailsPage from "@/pages/surveys/SurveyDetailsPage";
import SurveyEditPage from "@/pages/surveys/SurveyEditPage";
import SurveyAnswerPage from "@/pages/surveys/SurveyAnswerPage";
import NotFoundPage from "@/features/not-found/NotFoundPage";
import AccessInvitationPage from "@/pages/access-invitation/AccessInvitationPage";
import OrganizationWebsite from "@/pages/organization-website/OrganizationWebsite";
import MiSitioPage from "@/pages/mi-sitio/MiSitioPage";
import GlobalRoute from "./GlobalRoute";
import Quote from "@/features/quote/Quote";
import ThanksQuote from "@/features/quote/Thanks";
import QuoteDetails from "@/features/quote/QuoteDetails";
import Catalog from "@/features/catalog/Catalog";
import Checkout from "@/features/catalog/Checkout";
import Contact from "@/features/catalog/Contact";
import CatalogLayout from "@/features/catalog/components/CatalogLayout";
import routes from "@/constants/routes";
import NewWebsiteProvider from "@/pages/website/WebsiteProvider";
import Website from "@/pages/website/Website";
import MenuList from "@/pages/menu/components/MenuList";
import Menu from "@/pages/menu/Menu";
import DashboardPage from "@/pages/dashboard/DashboardPage";
import OrdersPage from "@/pages/organization-orders/OrdersPage";
import IMenuProvider from "@/pages/menu/components/MenuProvider";
import { CopilotProvider } from "@/features/copilot/CopilotProvider";
// checkout
import CheckoutPage from "@/pages/checkout/CheckoutPage";
import ContactForm from "@/pages/checkout/components/ContactForm";
import LocationForm from "@/pages/checkout/components/LocationForm";
import PaymentForm from "@/pages/checkout/components/PaymentForm";
import ConfirmationView from "@/pages/checkout/components/ConfirmationView/ConfirmationView";
import OrderStatusPage from "@/pages/order-status/OrderStatusPage";
// Reservations
import ReservationsPage from "@/pages/reservations/ReservationsPage";
import DateForm from "@/pages/reservations/components/DateForm";
import ReservationsContactForm from "@/pages/reservations/components/ContactForm";
import ReservationConfirmationView from "@/pages/reservations/components/ConfirmationView/ConfirmationView";
import TimeForm from "@/pages/reservations/components/TimeForm";
// BiteLink
import OnboardingLayout from "@/pages/onboarding/components/OnboardingLayout";
import OnboardingFinished from "@/pages/onboarding/components/OnboardingFinished";
import Onboarding from "@/pages/onboarding/Onboarding";
import SetupStep from "@/pages/onboarding/steps/SetupStep";
import OrdersLinkPage from "@/pages/organization-orders/OrdersLinkPage";
import BranchForm from "@/pages/checkout/components/BranchForm";
import ScheduleTimeForm from "@/pages/checkout/components/ScheduleTimeForm";
import UserProfile from "@/pages/user/UserProfile";
import OrganizationPricing from "@/pages/organization-pricing/OrganizationPricing";
import { LearningProvider } from "@/contexts/LearningContext";
import LearningVideosDrawer from "@/components/learning-center/LearningVideosDrawer";
import LearningCenter from "@/pages/learning-center/LearningCenter";
import ClientsPage from "@/pages/clients/ClientsPage";
import NewClientPage from "@/pages/clients/NewClientPage";
import ClientDetailsPage from "@/pages/clients/ClientDetailsPage";
import LoyaltyPage from "@/pages/loyalty/Loyalty";
import LoyaltyCustomer from "@/pages/loyalty-customer/LoyaltyCustomer";
import CustomerProfile from "@/pages/customer-profile/CustomerProfile";
import LegalDocumentsPage from "@/pages/legal/LegalDocumentPage";
import FirstStepsPage from "@/pages/first-steps/FirstSteps";
import TestDigitalPage from "@/pages/test-digital/TestDigitalPage";

const Routes = () => {
  const isMainDomain = document.location.host === "bitelink.app";
  const isDevMode = document.location.host.includes("localhost");

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
    >
      <AppRoutes>
        <Route element={<GlobalRoute />}>
          {/* PUBLIC /////////////////////////////////////////////////////////////////////////////////////////////// */}
              <Route path="comercios/:organizationId/orders/:orderId" element={<OrdersLinkPage />} />
              <Route path="comercios/:organizationId/surveys/:surveyId/submit" element={<SurveyAnswerPage />} />
              <Route path="test-digital" element={<TestDigitalPage />} />

          {/* LEGAL */}
          <Route path="legal/:type" element={<LegalDocumentsPage />} />


          {/* ONBOARDING */}
          {document.location.host.includes("bitelink.app") || isDevMode ? (
            <>
              <Route path="/onboarding" element={<Onboarding />} />
              <Route element={<PrivateRoutes />}>
                <Route element={<OnboardingLayout />}>
                  <Route path="/onboarding/setup" element={<SetupStep />} />
                  <Route path="/onboarding/finished" element={<OnboardingFinished />} />
                </Route>
              </Route>
            </>
          ) : null}

          {/* AUTHENTICATION */}
          <Route path={routes.login} element={<SignInPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="sign-up/verify-email" element={<CreatedAccount />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="access-invitation/:invitationId" element={<AccessInvitationPage />} />

          {/* HOSTED - WEBSITE */}
          <Route path={isMainDomain || isDevMode ? ":organizationAlias" : "/"} element={<NewWebsiteProvider />}>
            <Route index element={<Website />} />
            <Route element={<IMenuProvider />}>
              {/* MENUS */}
              <Route path="menus" element={<MenuList />} />
              <Route path="menus/:menuId?" element={<Menu />} />
              <Route path="loyalty" element={<LoyaltyCustomer />} />
              <Route path="perfil" element={<CustomerProfile />} />


              {/* CHECKOUT */}
              <Route path="orders/:orderId/checkout" element={<CheckoutPage />}>
                <Route path="contact" element={<ContactForm />} />
                <Route path="location" element={<LocationForm />} />
                <Route path="payment" element={<PaymentForm />} />
                <Route path="branch" element={<BranchForm />} />
                <Route path="time" element={<ScheduleTimeForm />} />
                <Route path="confirmation" element={<ConfirmationView />} />
              </Route>

              <Route path="orders/:orderId/status" element={<OrderStatusPage />} />
              {/* <Route path="orders/:orderId/link" element={<OrdersLinkPage />} /> */}

              {/* RESERVATIONS */}
              <Route path="reservations" element={<ReservationsPage />}>
                <Route path="contact" element={<ReservationsContactForm />} />
                <Route path="date" element={<DateForm />} />
                <Route path="time" element={<TimeForm />} />
                <Route path="confirmation" element={<ReservationConfirmationView />} />
              </Route>

              {/* QUOTES - AEM */}
              <Route path="cotizacion" element={<Quote />} />
              <Route element={<CatalogLayout />}>
                <Route path="catalogo" element={<Catalog />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="contacto" element={<Contact />} />
                <Route path="cotizacion/gracias" element={<ThanksQuote />} />
                <Route path="cotizacion/:quoteId" element={<QuoteDetails />} />
              </Route>



              {/* SURVEY */}
              <Route path="surveys/:surveyId" element={<SurveyAnswerPage />} />
            </Route>
          </Route>

          {/* Private */}
          <Route element={<PrivateRoutes />}>
            <Route element={<CopilotProvider />}>
              <Route path="/" element={<AdminLayout />}>
                <Route path="perfil" element={<Profile />} />
                <Route path="password" element={<ChangePassword />} />

                {/* Super Admin */}
                <Route path="super-admin/learning-center" element={<LearningCenter />} />
                <Route path="super-admin/clients" element={<ClientsPage />} />
                <Route path="super-admin/clients/:clientId" element={<ClientDetailsPage />} />
                <Route path="super-admin/clients/new" element={<NewClientPage />} />

                {/* Organization */}
                <Route
                  path="/comercios"
                  element={
                    <UserOrganizationProvider
                      websites // TODO: move this to websites page
                      content
                      tables
                      orders
                      categories
                      branches
                    />
                  }
                >
                  <Route element={<IncomingOrdersProvider><Outlet /></IncomingOrdersProvider>}>
                    <Route
                      element={
                        <LearningProvider>
                          <OrganizationLayout />
                          <LearningVideosDrawer />
                        </LearningProvider>
                      }
                    >
                      <Route index element={<Organizations />} />
                      <Route path={routes.organizations.firstSteps.main} element={<FirstStepsPage />} />
                      <Route path={routes.organizations.dashboard.main} element={<DashboardPage />} />
                      <Route path={":organizationId/perfil"} element={<UserProfile />} />
                      <Route path=":organizationId/pedidos/:orderId?" element={<OrdersPage />} />
                      <Route path=":organizationId/loyalty" element={<LoyaltyPage />} />
                      <Route path=":organizationId/contenido/:contentStatus/:contentId?" element={<OrganizationContent />} />
                      <Route path=":organizationId/mesas" element={<OrganizationTables />} />
                      <Route path=":organizationId/accesos" element={<AccessManagementPage />} />
                      <Route path=":organizationId/avatars" element={<OrganizationAvatars />} />
                      <Route path=":organizationId/menus" element={<OrganizationMenus />} />
                      <Route path=":organizationId/catalogo/crear" element={<CreateCatalog />} />
                      <Route path=":organizationId/catalogo/:menuId/editor" element={<CatalogEditor />} />
                      <Route path=":organizationId/detalles" element={<OrganizationDetails />} />
                      <Route path=":organizationId/configuraciones" element={<OrganizationSettings />} />
                      <Route path=":organizationId/faqs" element={<Faqs />} />
                      <Route path=":organizationId/websites" element={<OrganizationWebsite />} />
                      <Route path=":organizationId/mi-sitio" element={<MiSitioPage />} />
                      <Route path=":organizationId/suscripcion" element={<OrganizationPricing />} />
                      {/* Surveys */}
                      <Route path=":organizationId/surveys" element={<SurveysPage />} />
                      <Route path=":organizationId/surveys/:surveyId" element={<SurveyDetailsPage />} />
                      <Route path=":organizationId/surveys/:surveyId/edit" element={<SurveyEditPage />} />
                      {/* LEGAL
                  <Route path=":organizationId/legal/:type" element={<LegalDocumentsPage />} /> */}
                    </Route>
                  </Route>

                  <Route path="crear" element={<NewOrganization />} />
                </Route>
                <Route path="super-admin/plantillas" element={<UserOrganizationProvider showOrderDetails={false} content />}>
                  <Route element={<OrganizationLayout />}>
                    <Route index element={<Templates />} />
                    <Route path=":templateId" element={<Templates />} />
                  </Route>
                </Route>
              </Route>

              {/* ADMIN - MENU TOOLS */}
              <Route path="/comercios" element={<UserOrganizationProvider showOrderDetails={false} content />}>
                <Route path=":organizationId/menus/crear" element={<NewMenuWizard />} />
                <Route path=":organizationId/menus/:menuId">
                  <Route path="editor" element={<MenuEditor />} />
                  <Route path="configuracion" element={<Settings />} />
                </Route>
              </Route>

              {/* ADMIN - WEBSITE TOOLS */}
              <Route path="/comercios/:organizationId/websites/:websiteId" element={<NewWebsiteProvider />}>
                <Route index element={<Website />} />
                <Route path="editor" element={<WebsiteEditor />} />
              </Route>

              <Route path="/comercios/:organizationId/websites/crear" element={<NewWebsiteWizard />} />

              {/* ADMIN - TEMPLATE TOOLS */}
              <Route path="/super-admin/plantillas" element={<UserOrganizationProvider showOrderDetails={false} content />}>
                <Route element={<OrganizationProvider />}>
                  <Route index element={<Templates />} />
                  <Route path=":templateId" element={<Templates />} />
                  <Route path="crear" element={<NewTemplate />} />
                  <Route path=":templateId/:organizationId">
                    <Route path="editor/:elementId?" element={<TemplateEditor />} />
                    <Route path="configuracion" element={<TemplateSettings />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>

          <Route path="/*" element={<NotFoundPage />} />
        </Route>
      </AppRoutes>
    </BrowserRouter >
  );
};

export default Routes;
